import { render } from "preact";
import { App } from "./App";
import { applyTheme, readPref } from "./lib/theme";

applyTheme(readPref());

render(<App />, document.getElementById("app")!);
